import React, { useContext, useState } from 'react';
import { useQuery } from '@apollo/client';
import { possessive } from '../../../../../utils';
import { sanitize } from 'isomorphic-dompurify';
import { Checkbox } from '../../../../../components/fancyFieldsV2';
import { Error, Popup, Loading } from '../../../../../components/';
import { RegistrationActions } from '../../../../../contexts/RegistrationContext/RegistrationReducer';
import { RegistrationContext } from '../../../../../contexts';
import { WAIVER_QUERY } from '../../REGISTER_QUERIES_AND_MUTATIONS';
import classNames from 'classnames/bind';
import styles from '../../../../../styles/main.module.scss';

const { UPDATE_REGISTRATION_STATE } = RegistrationActions;

const cx = classNames.bind(styles);

const Waiver = props => {
  const { lightText } = props || {};
  const [hideWaiver, setHideWaiver] = useState(true);

  const [registerState, registerDispatch] = useContext(RegistrationContext);
  const { league, waiverAgreed } = registerState;

  const { organization, waiverId } = league || {};
  const { name: cityName } = organization || {};

  const {
    data = {},
    loading,
    error,
  } = useQuery(WAIVER_QUERY, {
    skip: !waiverId,
    fetchPolicy: 'network-only',
    variables: { _id: waiverId },
  });

  if (loading) {
    return <Loading type="inline" />;
  }
  if (error) {
    return <Error error={error} />;
  }

  const { waiver = {} } = data;
  const { name: waiverName, content: waiverContent } = waiver;

  const waiverHtml = sanitize(waiverContent);

  return (
    <>
      <Popup className="wide" hidden={hideWaiver} close={() => setHideWaiver(true)}>
        <h4>Liability Waiver - {waiverName}</h4>
        <div
          className={cx('waiver', 'text-left my-4')}
          dangerouslySetInnerHTML={{ __html: waiverHtml }}
        />
        <a onClick={() => setHideWaiver(true)} role="link" tabIndex={0}>
          Close
        </a>
      </Popup>
      <Checkbox
        className={cx('register-checkbox')}
        noLabel
        value={waiverAgreed}
        onChange={val => {
          registerDispatch({
            type: UPDATE_REGISTRATION_STATE,
            update: { waiverAgreed: val },
          });
        }}
      />
      <span className={cx(lightText ? 'light-text' : 'dark-text')}>
        By joining you agree to {possessive(cityName)}&nbsp;
        <a onClick={() => setHideWaiver(false)} role="button" tabIndex={0}>
          {waiverName || 'liability waiver'}
        </a>
        .
      </span>
    </>
  );
};

export default Waiver;
